module.exports = __webpack_public_path__ + "img/cart.3f484369.webp";